export function isEmpty(value, deep = false) {
    const checkersByTypeof = {
        number: (val) => isNaN(val) || val === -1,
        string: (val) => val.trim() === '',
        object: (val) => {
            if (deep) {
                const values = Object.values(val);
                return values.length === 0 || values.every((v) => isEmpty(v, true));
            }
            return Object.keys(val).length === 0;
        },
    };

    if (value === undefined || value === null) return true;
    if (Array.isArray(value)) return value.length === 0;

    const checker = checkersByTypeof[typeof value] ?? (() => false);
    return checker(value);
}
